import {IFaqQuestion} from "@pg-mono/faq";

const createQuestion = (name: string, answer: string): IFaqQuestion => ({name, answer, answer_text: answer});

export const PRICES_ADDRESS_FAQ_QUESTIONS: IFaqQuestion[] = [
    createQuestion(
        "Czym różni się mediana od średniej?",
        "Mediana to cena środkowa: połowa mieszkań była tańsza, połowa droższa. Średnia to suma cen podzielona przez ich liczbę, więc kilka bardzo drogich transakcji potrafi ją mocno podnieść. Przy niewielkiej liczbie transakcji mediana lepiej opisuje typowe mieszkanie, dlatego to nią się posługujemy."
    ),
    createQuestion(
        "Dlaczego dla części mieszkań nie ma statystyk?",
        "Publikujemy wyłącznie statystyki grup liczących co najmniej 3 transakcje. Jeśli pod danym adresem sprzedano mniej mieszkań o danej liczbie pokoi, nie pokazujemy dla nich ceny - pojedyncza transakcja nie mówi nic o typowej cenie. Widok wszystkich mieszkań łączy transakcje ze wszystkich rozmiarów, więc bywa dostępny nawet wtedy, gdy dla pojedynczego rozmiaru danych brakuje."
    )
];
import {IFaqQuestion} from "@pg-mono/faq";

const createQuestion = (name: string, answer: string): IFaqQuestion => ({name, answer, answer_text: answer});

export const PRICES_ADDRESS_FAQ_QUESTIONS: IFaqQuestion[] = [
    createQuestion(
        "Czym różni się mediana od średniej?",
        "Mediana to cena środkowa: połowa mieszkań była tańsza, połowa droższa. Średnia to suma cen podzielona przez ich liczbę, więc kilka bardzo drogich transakcji potrafi ją mocno podnieść. Przy niewielkiej liczbie transakcji mediana lepiej opisuje typowe mieszkanie, dlatego to nią się posługujemy."
    ),
    createQuestion(
        "Dlaczego dla części mieszkań nie ma statystyk?",
        "Publikujemy wyłącznie statystyki grup liczących co najmniej 3 transakcje. Jeśli pod danym adresem sprzedano mniej mieszkań o danej liczbie pokoi, nie pokazujemy dla nich ceny - pojedyncza transakcja nie mówi nic o typowej cenie. Widok wszystkich mieszkań łączy transakcje ze wszystkich rozmiarów, więc bywa dostępny nawet wtedy, gdy dla pojedynczego rozmiaru danych brakuje."
    )
];
